export default __webpack_public_path__ + "static/virtue-thumbnail-cafab11370fc2fe870c26e55f02019c4-cafab11370fc2fe870c26e55f02019c4.jpeg";